module.exports = __webpack_public_path__ + "static/media/giocattolicostumiImg.11ce6c81.png";